import React, { useState } from 'react';
import cx from 'classnames';

import TrustPilotImage from 'Containers/app/fastlane/TrustPilotImage/TrustPilotImage';
import { Content } from 'LegacySBCRA/Content/Content';

import type { TccCarCheckResponse } from '../CarCheckReport.types';

import { CheckerForm } from './SubComponents/CarCheckerForm/CarCheckerForm';
import { HeroImageCard } from './SubComponents/HeroImageCard/HeroImageCard';
import { HeroVehicleImage } from './SubComponents/HeroVehicleImage/HeroVehicleImage';

import styles from './CarCheckerHero.scss';

export const CarCheckerHero = ({ setTccData }: {
  setTccData: React.Dispatch<React.SetStateAction<TccCarCheckResponse | null>>;
}) => {
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  return (
    <div className={styles.component}>
      <Content className={styles.heroContentWrapper}>
        <main className={styles.heroWrapper}>
          <div className={styles.heroInnerWrapper}>
            <section className={styles.heroVRM}>
              <span className={styles.eyebrow}>Free Car Check</span>
              <h1 className={styles.heading}>
                Free Car Check
              </h1>
              <p className={styles.strap}>
                Check your car's MOT and tax status for free.
              </p>
              <CheckerForm { ...{ setTccData } } />
              <TrustPilotImage className={styles.trustpilot} />
            </section>
          </div>
          <section className={styles.imageContainer}>
            <div className={cx(styles.car, {
              [styles.imageLoaded]: imageLoaded,
            })}>
              <HeroImageCard />
              <HeroVehicleImage {...{ setImageLoaded }} />
            </div>
          </section>
        </main>
      </Content>
    </div>
  );
};
